// extracted by mini-css-extract-plugin
module.exports = {"item":"asset-collection-module--item--21tEO"};